/* eslint-disable react/prop-types */
import { Radio } from 'antd';
import React from 'react';
import { getInvitesInReviewMatchingTheDate } from '../../logic';
import { RadioGroup } from './styled';

const GarageOptions = ({ invites }) =>
  invites.map(({ invitationId, garage }) => (
    <Radio key={invitationId} value={invitationId}>
      {garage?.businessName}
    </Radio>
  ));

export const SelectGarageStep = ({
  handleGarageInvitationSelected,
  garageInvites,
  invitationId,
  dateOptionSelected,
}) => {
  const invitesInReviewMatchingTheDate = getInvitesInReviewMatchingTheDate(garageInvites, dateOptionSelected);

  if (invitesInReviewMatchingTheDate.length === 1) {
    // If there is only one option, select it directly
    handleGarageInvitationSelected(invitesInReviewMatchingTheDate[0].invitationId);
  }

  const onGarageSelect = (option) => {
    handleGarageInvitationSelected(option.target.value);
  };

  return (
    <>
      <p>
        The garages shown below are the garages entered in the reschedule proposal that correspond to the date
        chosen in the previous step. Please pick the garage to allocate this booking to.
      </p>

      <RadioGroup value={invitationId} onChange={onGarageSelect}>
        <GarageOptions invites={invitesInReviewMatchingTheDate} />
      </RadioGroup>
    </>
  );
};

export default SelectGarageStep;
